import Account from "../../components/Account";
function AccountPage() {
  return (
    <div>
      <Account />
    </div>
  );
}

export default AccountPage;
